module.exports = __webpack_public_path__ + "img/slot.60ec4973.jpg";